const ReactDOM = require('react-dom');
const ownerDocument = require('dom-helpers/ownerDocument');

module.exports = function (componentOrElement) {
  // eslint-disable-next-line react/no-find-dom-node
  return ownerDocument(ReactDOM.findDOMNode(componentOrElement));
};
